var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEurUah(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6500_10940)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6500_10940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 4.6958L12.3898 5.89153H13.647L12.6298 6.63052L13.0184 7.82625L12.0013 7.08722L10.9841 7.82625L11.3726 6.63052L10.3555 5.89153H11.6127L12.0013 4.6958Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83377 6.83528L7.95408 7.40603L8.84306 6.51709L8.64633 7.75881L9.76659 8.32961L8.52483 8.52629L8.32814 9.76811L7.75734 8.64784L6.51562 8.84457L7.40461 7.95559L6.83377 6.83528Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69531 12.0003L5.89105 11.6117V10.3545L6.62998 11.3717L7.82577 10.9831L7.08669 12.0003L7.82577 13.0174L6.62998 12.6289L5.89105 13.6461V12.3888L4.69531 12.0003Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83377 17.1652L7.40456 16.0449L6.51562 15.1559L7.75739 15.3527L8.32809 14.2324L8.52483 15.4742L9.76655 15.6709L8.64642 16.2417L8.84306 17.4834L7.95408 16.5944L6.83377 17.1652Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 19.3047L11.6127 18.1089H10.3555L11.3727 17.37L10.9841 16.1743L12.0013 16.9133L13.0184 16.1743L12.6298 17.37L13.647 18.1089H12.3897L12.0013 19.3047Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1632 17.1652L16.0429 16.5945L15.1539 17.4834L15.3506 16.2416L14.2305 15.6709L15.4722 15.4742L15.6689 14.2324L16.2396 15.3527L17.4813 15.1559L16.5924 16.045L17.1632 17.1652Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3022 12.0003L18.1065 12.3888V13.6461L17.3675 12.6289L16.1719 13.0174L16.9109 12.0003L16.1719 10.9831L17.3676 11.3717L18.1065 10.3545V11.6118L19.3022 12.0003Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1632 6.83523L16.5924 7.95554L17.4814 8.84453L16.2396 8.64775L15.6689 9.76801L15.4722 8.52625L14.2305 8.32951L15.3506 7.75876L15.1539 6.51709L16.043 7.40603L17.1632 6.83523Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C18.3513 0.5 23.5 5.64872 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64872 23.5 0.5 18.3513 0.5 12C0.5 5.64872 5.64872 0.5 12 0.5Z",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6500_10940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 36C30.6274 36 36 30.6274 36 24C36 17.3726 30.6274 12 24 12C17.3726 12 12 17.3726 12 24C12 30.6274 17.3726 36 24 36Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C12 17.3726 17.3726 12 24 12C30.6274 12 36 17.3726 36 24",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12.5C30.3513 12.5 35.5 17.6487 35.5 24C35.5 30.3513 30.3513 35.5 24 35.5C17.6487 35.5 12.5 30.3513 12.5 24C12.5 17.6487 17.6487 12.5 24 12.5Z",
    stroke: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6500_10940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6500_10940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6500_10940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurUah);
export default __webpack_public_path__ + "static/media/eur-uah.594a1eda62549d186318e5fd4f65e12a.svg";
export { ForwardRef as ReactComponent };